import { Login } from 'digicon-web-login/login';
import OverrideRegister from './OverrideRegisterModule';
import { i18n } from 'digicon-web-localization/localization';

export class OverrideLogin extends Login {
    constructor(props) {
        super(props);
        this.props = props;
        this._register = new OverrideRegister(props);

        //subscribe to utilities events
        this._recover.subscribe('onClosed', () => this.openLoginForm());
        this._recover.subscribe('onRecoverPasswordSent', () => {
            let container = document.getElementById(this.props.container);
            if (!container) return;

            this.openLoginForm();
            container.querySelector('.loginUI_error').innerHTML = i18n('lgnRecoverEmailSent');

            this.trigger('onRecoverPasswordSent');
        });

        this._register.subscribe('onUserRegistered', (userJson) => {
            let container = document.getElementById(this.props.container);
            if (!container) return;

            this.openLoginForm();
            container.querySelector('.loginUI_error').innerHTML = i18n('lgnregistered');

            const email = document.querySelector('#loginUI_input_email');
            email.value = userJson.email;
            const pass = document.querySelector('#loginUI_input_password');
            pass.value = '';

            this.trigger('onUserRegistered', userJson);
        });
        this._register.subscribe('onClosed', () => this.openLoginForm());
    }
}